import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../common/html/element'
import { getAllParentChecked } from '../../../../common/tree/helper'
import { INDUSTRY_TYPE, MAX_INDUSTRY_LEVEL } from '../constant'
import {
  selectIndustryICB,
  selectIndustryICBById,
  selectIndustryVSIC,
  selectIndustryVSICById,
} from '../store/slice'
import classes from './index.module.scss'

export const Industry = ({ data }) => {
  const industryVSIC = useSelector(selectIndustryVSIC)
  const industryICB = useSelector(selectIndustryICB)
  const industryVSICById = useSelector(selectIndustryVSICById())
  const industryICBById = useSelector(selectIndustryICBById())

  const treeData =
    data.industryType === INDUSTRY_TYPE.ICB ? industryICB : industryVSIC
  const industryData =
    data.industryType === INDUSTRY_TYPE.ICB ? industryICBById : industryVSICById

  const listParentChecked = getAllParentChecked(
    treeData,
    'id',
    data.listIdCheckedTree,
  )

  const listData = listParentChecked.map((id) => industryData[id])
  return new Array(MAX_INDUSTRY_LEVEL).fill(undefined).map((val, index) => {
    const level = index + 1
    const industries = listData.filter((item) => item.level === level)
    return industries.length ? (
      <IndustryItem key={level} level={level} industries={industries} />
    ) : null
  })
}

const IndustryItem = ({ level, industries }) => {
  return (
    <Element className={classes.industryItem}>
      <Element className={classes.level}>
        <Translate value="screening.LEVEL" /> {level}
      </Element>
      <Element className={classes.industryDetail}>
        {industries.map((item) => (
          <Element key={item.id} className={classes.industry}>
            <Element className={classes.code}>{item.code}</Element>
            <Element className={classes.name}>{item.name}</Element>
          </Element>
        ))}
      </Element>
    </Element>
  )
}
